import { Component, OnInit } from '@angular/core';
import GuestFiltersView from "./guest-filters.component.html";

@Component({
  selector: 'event-guest-filters',
  template: GuestFiltersView
})
export class GuestFiltersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
